import React, { useEffect, useState } from "react";

import useSurvey from "../../hooks/useSurvey";
import { Box, Typography } from "@mui/material";

import Variability_Plain from "./Variability_Plain";
import Variability_Image from "./Variability_Image";
import Variability_Grid from "./Variability_Grid";
import Variability_Html from "./Variability_Html";
import Variability_Template from "./Variability_Template";

const SurveyEntry_Variability = ({ section, question, call }) => {
  const { getQuestionVariabilityData, getSectionVariabilityData } = useSurvey();

  const [variabilityData, setVariabilityData] = useState(null);
  const [displayType, setDisplayType] = useState(null);

  useEffect(() => {
    getData();
  }, [call]);

  const getData = async () => {
    if (question) {
      setVariabilityData(
        await getQuestionVariabilityData(section, question, call)
      );
      setDisplayType(question.variability.displayType);
    } else if (section) {
      setVariabilityData(await getSectionVariabilityData(section, call));
      setDisplayType(section.variability.displayType);
    }
  };

  if (!displayType) return;

  return (
    <>
      {displayType === "plain" && (
        <Variability_Plain variabilityData={variabilityData} />
      )}
      {displayType === "image" && (
        <Variability_Image variabilityData={variabilityData} />
      )}
      {displayType === "grid" && (
        <Variability_Grid variabilityData={variabilityData} />
      )}
      {displayType === "template" && (
        <Variability_Template
          variability={question ? question.variability : section.variability}
          variabilityData={variabilityData}
        />
      )}
      {displayType === "html" && (
        <Variability_Html variabilityData={variabilityData} />
      )}
    </>
  );
};

export default SurveyEntry_Variability;
